export default __webpack_public_path__ + "static/media/gl-9.486f92ac.png";